/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Remix
 */
export interface Remix {
    /**
     * 
     * @type {string}
     * @memberof Remix
     */
    parentTrackId: string;
    /**
     * 
     * @type {User}
     * @memberof Remix
     */
    user: User;
    /**
     * 
     * @type {boolean}
     * @memberof Remix
     */
    hasRemixAuthorReposted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Remix
     */
    hasRemixAuthorSaved: boolean;
}

/**
 * Check if a given object implements the Remix interface.
 */
export function instanceOfRemix(value: object): value is Remix {
    let isInstance = true;
    isInstance = isInstance && "parentTrackId" in value && value["parentTrackId"] !== undefined;
    isInstance = isInstance && "user" in value && value["user"] !== undefined;
    isInstance = isInstance && "hasRemixAuthorReposted" in value && value["hasRemixAuthorReposted"] !== undefined;
    isInstance = isInstance && "hasRemixAuthorSaved" in value && value["hasRemixAuthorSaved"] !== undefined;

    return isInstance;
}

export function RemixFromJSON(json: any): Remix {
    return RemixFromJSONTyped(json, false);
}

export function RemixFromJSONTyped(json: any, ignoreDiscriminator: boolean): Remix {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentTrackId': json['parent_track_id'],
        'user': UserFromJSON(json['user']),
        'hasRemixAuthorReposted': json['has_remix_author_reposted'],
        'hasRemixAuthorSaved': json['has_remix_author_saved'],
    };
}

export function RemixToJSON(value?: Remix | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parent_track_id': value.parentTrackId,
        'user': UserToJSON(value.user),
        'has_remix_author_reposted': value.hasRemixAuthorReposted,
        'has_remix_author_saved': value.hasRemixAuthorSaved,
    };
}

